<ng-container #container><ng-container>

<ng-template #fakeTile>
  <tsh-tile [tile]="tile"
            [visualizationConfig]="visualizationConfig"
            [data]="data">
  </tsh-tile>
<ng-template>
